import { GridColumnType } from "../../../data/gridColumnType";


export const ViewCpdAttendanceListConfig = {
  columns: [
    {
      name: "Select",
      fieldName: "isApprove",
      colType: GridColumnType.CHECKBOX,
      colSettings: {
        allowEdit: false,
        isDisabled: (rowData) => rowData.isDisabled === true
      },
      allowShort: false
    },
    {
      name: "GMP Name",
      fieldName: "gmpName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "GMP Number",
      fieldName: "gmpNumber",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Remark",
      fieldName: "remark",
      colType: GridColumnType.Text,

    },
    // {
    //   name: "Action",
    //   colType: GridColumnType.ACTION,
    //   defaultAction: {
    //     allowEdit: false,
    //     allowDelete: true,
    //   },
    //   customActions: [

    //   ],
    // },
  ],
};
